import { render } from "./ClientsRankingTotalValueSold.vue?vue&type=template&id=8ea77b74&ts=true"
import script from "./ClientsRankingTotalValueSold.vue?vue&type=script&lang=ts"
export * from "./ClientsRankingTotalValueSold.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__